export { NavigationService } from 'sce-core';
// #TODO-LIBRARY NavigationService Used in 185 places in 83 files WMS /src/app.. should be re-referenced from library directly



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/core/navigation.service.ts